import React,{useState,useEffect,useRef} from "react";
import axios from '../../../../plugins/axios'
import Toast from '../../../../plugins/useToast'
import { useTranslation } from "react-i18next";
import { useRecoilState } from 'recoil';
import { selectBedInfoState } from '../../../../plugins/recoil';
import {ReactComponent as IconCloseBlack} from '../../../../assets/icons/ic-close-black.svg';
import {ReactComponent as IconArrowUp} from '../../../../assets/icons/ic-arrow-up-gray.svg'
import {ReactComponent as IconArrowDown} from '../../../../assets/icons/ic-arrow-down-gray.svg'
import {ReactComponent as IconCheck} from '../../../../assets/icons/ic-check_blue.svg';

import { pad } from '../../../../plugins/common'

const Transfer = ({transferPatientInfo,confirmTransfer,handleSetConfirmTransfer,handleClose,getDeviceData,handleSaveParameter}) => {
    const { t } = useTranslation()
    const isFirstRender = useRef(true);
    const [selectBedInfo, setSelectBedInfo] = useRecoilState(selectBedInfoState) 
    const [transferWard, setTransferWard] = useState([]); //이동할 병동 리스트
    const [transferDevice, setTransferDevice] = useState([]); //이동할 병동의 병상 리스트
    const [transferSelectInfo, setTransferSelectInfo] = useState({
        ward : { value : '' , label : ''}, 
        device : { value : '' , label : '', serial : ''}
    }); 
    const [isDropdownOpen, setIsDropdownOpen] = useState(); //이동할 병동의 병상 리스트    
    const [isTransferDisabled, setIsTransferDisabled] = useState(true); //이동 버튼 활성화 여부

    //최초 접속 시 데이터 가져오기.
    const getTransferInfo = async () => {
        const wardRes = await axios.get(`/wards?page=0`);
        if (wardRes.code != '200') throw wardRes;                        
        setTransferWard(wardRes.data.content);
        
        setTransferSelectInfo({
            ward : { value : transferPatientInfo.ward.value , label : transferPatientInfo.ward.label}, 
            device : { value : transferPatientInfo.device.value , label : transferPatientInfo.device.label, serial : transferPatientInfo.device.serial }
        });        
    }

    //Ward를 선택 했을 때 빈 Device List 가져오기 
    const getEmptyDevice = async (wardId) => {
        try{
            const deviceRes = await axios.get(`/devices?wardId=${wardId}`);
            if (deviceRes.code != '200') throw deviceRes;              

            //Ward 기준으로 Patient가 없는 Device List 가져오기 (내가 선택한 Device는 포함해서 리스트 만듬)
            const emptyDevices = deviceRes.data.content
            .filter(device => device.patientId == null || device.patientId == '' || device.id == selectBedInfo.deviceId)
            .map(device => ({
                value: device.id,
                label: device.bedNumber,
                serial : device.serial
            })).sort((a, b) => {
                // selectBedInfo.deviceId와 같은 id를 맨 앞으로
                if (a.value === selectBedInfo.deviceId) return -1;
                if (b.value === selectBedInfo.deviceId) return 1;

                // bedNumber를 숫자로 변환하여 비교 (숫자 정렬)
                const numA = Number(a.label);
                const numB = Number(b.label);
                if (!isNaN(numA) && !isNaN(numB)) return numA - numB;
                return String(a.label).localeCompare(String(b.label));                
            });            
            
            setTransferDevice(emptyDevices);

            // emptyDevices에서 selectBedInfo.deviceId와 같은 id를 찾음 (기존에 선택한 Device가 있으면 그 값을 유지하고 없으면 빈 값으로 설정)
            const selectedDevice = emptyDevices.find(device => device.value === selectBedInfo.deviceId);

            setTransferSelectInfo(prev => ({
                ...prev,
                device: selectedDevice
                    ? { value: selectedDevice.value, label: selectedDevice.label, serial: selectedDevice.serial }
                    : { value: '', label: '' }
            }));
        } catch (err) {
            console.warn(err)
        }
    }    

    //Transfer Save 버튼 클릭 이벤트
    const handleTransferSave = async () => {
        try{
            const payload = {
                deviceId : transferSelectInfo.device.value,
            }

            const res = await axios.patch(`/patient/${transferPatientInfo.transferId}/transfer/device`,payload);
            if (res.code != '200') throw res;
            
            console.log('[handleTransferSave]res => ', res);            
            //handleClose();
            handleSaveParameter();
            handleSetConfirmTransfer(false,1)            
            getDeviceData(selectBedInfo.deviceId); //이동 후 Device Data 다시 세팅
            
            //이거 이렇게 하면 되는거야?
            setSelectBedInfo(
                prev => ({
                    ...prev,
                    patientId : null,
                    patientName : null,
                    devicePatientId : null
                })
            )

            Toast({ isSuccess: true, msg: t(`bedSetting.transferSuccess`) });
        }catch (err) {
            Toast({ isSuccess: false, msg: t(`bedSetting.transferFail`) });
            console.warn(err)
        }
    }

    //Ward를 변경 했을 때 빈 Device List 가져오기
    useEffect(() => {
        if(isFirstRender.current){
            isFirstRender.current = false;
            return;
        }

        if(transferSelectInfo?.ward){
            getEmptyDevice(transferSelectInfo.ward.value);
        }
    }, [transferSelectInfo?.ward])

    // transferSelectInfo가 바뀔 때마다 disabled 상태 갱신
    useEffect(() => {
        const { ward, device } = transferSelectInfo;
        if (
            ward.value && ward.label &&
            device.value && device.label
        ) {
            setIsTransferDisabled(false);
        } else {
            setIsTransferDisabled(true);
        }
    }, [transferSelectInfo]);

    useEffect(() => {        
        getTransferInfo()
        const handleClickOutside = (event) => {
            if (!event.target.closest('.select-dropdown')) {
                setIsDropdownOpen(null);
            }
        };
        document.addEventListener('click', handleClickOutside);
        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, [transferPatientInfo]);

    return (
        <div className="absolute inset-0 bg-black bg-opacity-30 flex items-center justify-center z-[9999]">                    
            <div className={`flex flex-col ${confirmTransfer.step == 1 ? 'w-[360px] h-[244px]' : 'w-[522px] h-[387px]'} items-start flex-shrink-0 rounded-[8px] bg-[#DEDEDE] shadow-[0px_12px_12px_0px_rgba(0,0,0,0.60)]`}>
                <div className='flex h-[38px] px-[12px] pt-[12px] pb-[8px] pl-[20px] justify-between items-center flex-shrink-0 self-stretch bg-[#CECECE] rounded-t-[8px] rounded-b-none'>
                    <span className='text-[#000] font-pretendard text-[16px] font-normal leading-[110%] text-center'>{t('bedSetting.transfer')}</span>
                    <IconCloseBlack onClick={()=> handleSetConfirmTransfer(false,1)} className="cursor-pointer"/>
                </div>
                {
                    confirmTransfer.step == 1 && (
                        <>
                            <div className="flex flex-wrap px-[20px] justify-center items-center self-stretch">    
                                <div className="w-full mb-[20px] mt-[20px]">
                                    <p className={`text-[#444] text-[14px] font-normal leading-[110%] mb-[6px]`}>{t('bedSetting.ward')}</p>
                                    <div className="relative select-dropdown"> 
                                        <div className="bg-[#fff] text-[#000] h-[32px] px-[8px] rounded-[6px] cursor-pointer flex items-center justify-between border border-[#CECECE]"
                                        onClick={(e) => { e.stopPropagation(); setIsDropdownOpen('ward');}}>
                                            <div className="w-full">{transferSelectInfo.ward.label}</div>
                                            <div className="pointer-events-none">
                                                {isDropdownOpen == 'ward' ? <IconArrowUp /> : <IconArrowDown />}
                                            </div>
                                        </div>
                                        {isDropdownOpen == 'ward' && (
                                            <div className="gender-dropdow absolute w-full top-[35px] bg-[#fff] py-[8px] rounded-[6px] border border-[#CECECE] shadow-[0px_12px_12px_0px_rgba(0,0,0,0.4)] z-20">                                            
                                                {transferWard.map((ward, _) => {
                                                    return (
                                                        <div                                                             
                                                            key={`${ward.name}`}
                                                            className={`bg-[#fff] cursor-pointer h-[32px] flex items-center justify-between px-[8px] hover:bg-[#F4F4F4] 
                                                            ${ward.id == transferSelectInfo.ward.value ? "text-[#3182F7]" : "text-black"}`}                                                            
                                                            onClick={() => { setIsDropdownOpen(null); setTransferSelectInfo(prev => ({ ...prev, ward : {value : ward.id , label : ward.name} }));}}>
                                                            {ward.name}
                                                            {ward.id == transferSelectInfo.ward.value && (
                                                                <IconCheck className="w-4 h-4 ml-2" />
                                                            )}
                                                        </div>
                                                    )
                                                })}
                                            </div>
                                        )}
                                    </div>
                                </div>
                                <div className="w-full mb-[20px]">
                                    <p className={`text-[#444] text-[14px] font-normal leading-[110%] mb-[6px]`}>{t('bedSetting.selectDestinationBed')}</p>
                                    <div className="relative select-dropdown">
                                        
                                        {
                                            transferDevice && transferDevice.length > 0 ? (
                                                <>
                                                    <div className="bg-[#fff] text-[#000] w-full h-[32px] px-[8px] rounded-[6px] cursor-pointer flex items-center justify-between border border-[#CECECE]"
                                                    onClick={(e) => { e.stopPropagation(); setIsDropdownOpen('device');}}>
                                                        <div className="w-[200px]">Bed-{pad(transferSelectInfo.device.label,2)} ({transferSelectInfo.device.serial})</div>
                                                        <div className="pointer-events-none">
                                                            {isDropdownOpen == 'device' ? <IconArrowUp /> : <IconArrowDown />}
                                                        </div>
                                                    </div>
                                                    {isDropdownOpen == 'device' && (
                                                        <div className="gender-dropdow w-full max-h-[150px] overflow-y-auto scrollbar scrollbar--gray absolute top-[35px] bg-[#fff] py-[8px] rounded-[6px] border border-[#CECECE] shadow-[0px_12px_12px_0px_rgba(0,0,0,0.4)] z-20">                                            
                                                            {transferDevice.map((device, _) => {
                                                                return (
                                                                    <div                                                             
                                                                        key={`${device.value}`} 
                                                                        className={`bg-[#fff] cursor-pointer h-[32px] flex items-center justify-between px-[8px] hover:bg-[#F4F4F4] 
                                                                        ${device.value == transferSelectInfo.device.value ? "text-[#3182F7]" : "text-black"}`}                                                            
                                                                        onClick={() => { setIsDropdownOpen(null); setTransferSelectInfo(prev => ({ ...prev, device : {value : device.value , label : device.label,serial : device.serial}  }));}}>
                                                                        Bed-{pad(device.label,2)} ({device.serial})
                                                                        {device.value == transferSelectInfo.device.value && (
                                                                            <IconCheck className="w-4 h-4 ml-2" />
                                                                        )}
                                                                    </div> 
                                                                )
                                                            })}
                                                        </div>
                                                    )}                                                            
                                                </>
                                            ) : (
                                                <>
                                                    <div className="bg-[#fff] text-[#DEDEDE] w-full h-[32px] px-[8px] rounded-[6px] cursor-pointer flex items-center justify-between border border-[#CECECE]">
                                                        <div className="w-[220px]"></div>                                                                    
                                                    </div>
                                                </>
                                            )
                                        }
                                    </div>
                                </div>
                            </div>
                            <div className='flex px-[20px] justify-end items-center gap-[8px] self-stretch'>
                                <button
                                    className="flex w-[88px] h-[28px] px-[8px] py-[7px] justify-center items-center gap-[8px] rounded-[6px] border border-[#B8B8B8] bg-gradient-to-b from-[#FFF] to-[#DEDEDE] text-black text-center font-pretendard text-[16px] font-light leading-[110%]"
                                    onClick={()=> handleSetConfirmTransfer(false,1)}
                                >
                                    {t('bedSetting.cancel')}
                                </button>
                                <button
                                    className="flex w-[88px] h-[28px] px-[8px] py-[7px] justify-center items-center gap-[8px] rounded-[6px] border border-[#5E5E5E] bg-gradient-to-b from-[#5E5E5E] to-[#383838] text-white text-center font-pretendard text-[16px] font-light leading-[110%]"
                                    disabled={isTransferDisabled}
                                    style={{ opacity: isTransferDisabled ? 0.5 : 1 }}   
                                    onClick={() => handleSetConfirmTransfer(true,2)}
                                >
                                    {t('bedSetting.transfer')}
                                </button>
                            </div>
                        </>
                    )
                }
                {
                    confirmTransfer.step == 2 && (
                        <>
                            <div className="w-full p-[20px]">
                                <div className="flex flex-nowrap gap-[1px] mb-[1px]">                           
                                    <div className="flex w-[120px] bg-[#262626] h-[30px] p-[8px_4px] justify-center items-center gap-[4px]"></div>
                                    <div className="flex w-[180px] bg-[#262626] h-[30px] p-[8px_4px] justify-center items-center gap-[4px]">
                                        <span className="text-[#CECECE] text-center font-pretendard text-[14px] font-light leading-[110%]">{t('bedSetting.from')}</span>
                                    </div>
                                    <div className="flex w-[180px] bg-[#262626] h-[30px] p-[8px_4px] justify-center items-center gap-[4px]">
                                        <span className="text-[#CECECE] text-center font-pretendard text-[14px] font-light leading-[110%]">{t('bedSetting.to')}</span>
                                    </div>
                                </div>
                                <div className="flex flex-nowrap gap-[1px] mb-[1px]">                           
                                    <div className="flex w-[120px] bg-[#343434] h-[30px] p-[8px_4px] justify-center items-center gap-[4px]">
                                        <span className="text-white font-pretendard text-[14px] font-light leading-[110%]">{t('bedSetting.ward')}</span>
                                    </div>  
                                    <div className="flex w-[180px] bg-[#fff] h-[30px] p-[8px_4px] justify-center items-center gap-[4px]">
                                        <span className="text-[#000] text-center font-pretendard text-[14px] font-light leading-[110%]">{transferPatientInfo?.ward.label}</span>
                                    </div>
                                    <div className="flex w-[180px] bg-[#fff] h-[30px] p-[8px_4px] justify-center items-center gap-[4px]">
                                        <span className="text-[#000] text-center font-pretendard text-[14px] font-light leading-[110%]">{transferSelectInfo?.ward.label}</span>
                                    </div>
                                </div>
                                <div className="flex flex-nowrap gap-[1px] mb-[1px]">                           
                                    <div className="flex w-[120px] bg-[#343434] h-[30px] p-[8px_4px] justify-center items-center gap-[4px]">
                                        <span className="text-white font-pretendard text-[14px] font-light leading-[110%]">{t('bedSetting.bedName')}</span>
                                    </div>
                                    <div className="flex w-[180px] bg-[#fff] h-[30px] p-[8px_4px] justify-center items-center gap-[4px]">
                                        <span className="text-[#000] text-center font-pretendard text-[14px] font-light leading-[110%]">{t('bedSetting.bed')}-{pad(transferPatientInfo?.device.label,2)}</span>
                                    </div>
                                    <div className="flex w-[180px] bg-[#fff] h-[30px] p-[8px_4px] justify-center items-center gap-[4px]">
                                        <span className="text-[#000] text-center font-pretendard text-[14px] font-light leading-[110%]">{t('bedSetting.bed')}-{pad(transferSelectInfo?.device.label,2)}</span>
                                    </div>
                                </div>
                                <div className="flex flex-nowrap gap-[1px] mb-[1px]">                           
                                    <div className="flex w-[120px] bg-[#343434] h-[30px] p-[8px_4px] justify-center items-center gap-[4px]">
                                        <span className="text-white font-pretendard text-[14px] font-light leading-[110%]">{t('bedSetting.serialNumber')}</span>
                                    </div>
                                    <div className="flex w-[180px] bg-[#fff] h-[30px] p-[8px_4px] justify-center items-center gap-[4px]">
                                        <span className="text-[#000] text-center font-pretendard text-[14px] font-light leading-[110%]">{transferPatientInfo?.device?.serial}</span>
                                    </div>
                                    <div className="flex w-[180px] bg-[#fff] h-[30px] p-[8px_4px] justify-center items-center gap-[4px]">
                                        <span className="text-[#000] text-center font-pretendard text-[14px] font-light leading-[110%]">{transferSelectInfo?.device?.serial}</span>
                                    </div>
                                </div>
                                <div className="flex flex-nowrap gap-[1px] mb-[1px]">                           
                                    <div className="flex w-[120px] bg-[#343434] h-[30px] p-[8px_4px] justify-center items-center gap-[4px]">
                                        <span className="text-white font-pretendard text-[14px] font-light leading-[110%]">{t('bedSetting.patientName')}</span>
                                    </div>
                                    <div className="flex w-[180px] bg-[#fff] h-[30px] p-[8px_4px] justify-center items-center gap-[4px]">
                                        <span className="text-[#000] text-center font-pretendard text-[14px] font-light leading-[110%]">{transferPatientInfo?.PatientName}</span>
                                    </div>
                                    <div className="flex w-[180px] bg-[#fff] h-[30px] p-[8px_4px] justify-center items-center gap-[4px]">
                                        <span className="text-[#000] text-center font-pretendard text-[14px] font-light leading-[110%]">{t('bedSetting.notSet')}</span>
                                    </div>
                                </div>
                                 <div className="flex flex-nowrap gap-[1px] mb-[1px]">                           
                                    <div className="flex w-[120px] bg-[#343434] h-[30px] p-[8px_4px] justify-center items-center gap-[4px]">
                                        <span className="text-white font-pretendard text-[14px] font-light leading-[110%]">{t('bedSetting.patientId')}</span>
                                    </div>
                                    <div className="flex w-[180px] bg-[#fff] h-[30px] p-[8px_4px] justify-center items-center gap-[4px]">
                                        <span className="text-[#000] text-center font-pretendard text-[14px] font-light leading-[110%]">{transferPatientInfo?.PatientId}</span>
                                    </div>
                                    <div className="flex w-[180px] bg-[#fff] h-[30px] p-[8px_4px] justify-center items-center gap-[4px]">
                                        <span className="text-[#000] text-center font-pretendard text-[14px] font-light leading-[110%]">{t('bedSetting.notSet')}</span>
                                    </div>
                                </div>
                                <div className="flex flex-wrap mt-[10px]">
                                    <p className="text-[#444] font-pretendard text-[14px] font-normal leading-[120%] mb-[5px]">{t('bedSetting.transferWarn')}​</p>
                                    <p className="text-[#444] font-pretendard text-[14px] font-normal leading-[120%]">{t('bedSetting.transferWarn2', { fromBed: pad(transferPatientInfo?.device.label,2), toBed: pad(transferSelectInfo?.device.label,2) })}</p>
                                </div>
                            </div>
                            
                            <div className='flex px-[20px] py-[12px] justify-end items-center gap-[8px] self-stretch'>
                                <button
                                    className="flex min-w-[88px] h-[28px] px-[8px] py-[7px] justify-center items-center gap-[8px] rounded-[6px] border border-[#B8B8B8] bg-gradient-to-b from-[#FFF] to-[#DEDEDE] text-black text-center font-pretendard text-[16px] font-light leading-[110%]"
                                    onClick={()=> handleSetConfirmTransfer(false,1)}
                                >
                                    {t('bedSetting.cancel')}
                                </button>
                                <button
                                    className="flex min-w-[88px] h-[28px] px-[8px] py-[7px] justify-center items-center gap-[8px] rounded-[6px] border border-[#5E5E5E] bg-gradient-to-b from-[#5E5E5E] to-[#383838] text-white text-center font-pretendard text-[16px] font-light leading-[110%]"
                                    onClick={() => handleTransferSave()}
                                >
                                    {t('bedSetting.ok')}
                                </button>
                            </div>
                        </>
                    )
                }
            </div>
        </div>
    );
};

export default Transfer;
